var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-page',[_c('site-header',{staticClass:"app__header",attrs:{"keep-alive":""}}),_c('main',{staticClass:"app__main"},[_vm._t("default")],2),_c('tab-bar',{staticClass:"app__tab-bar"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }